export default __webpack_public_path__ + "static/media/Sc.5be06bd5.jpeg";